import styled from 'styled-components';

export const StyledWrapper = styled.div`
  .clickable-statistic {
    ${(p:any) => p.selected ? 'background-color: #d1e9fd;' : '' }
    cursor: pointer;
    padding: 2px 10px;
    &:hover {
      border: 1px solid rgb(233, 237, 240);
      background-color: #e1f1ff;
    }
  }
`;
